module.exports = __webpack_public_path__ + "img/museum.c5aa98a8.png";